import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types'
//MUI
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Box from '@material-ui/core/Box';
//ICONOS
import PlayCircleOutlineIcon from '@material-ui/icons/PlayCircleOutline';
import StopIcon from '@material-ui/icons/Stop';
import AutorenewIcon from '@material-ui/icons/Autorenew';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';

//DS
import useInterval from '../../../hooks/useInterval';
import { validacion } from 'lib.common';
const { esFuncion } = validacion;

function timeFormatter(tiemInMs) {
   const seconds = ('0' + (Math.floor(tiemInMs / 1000) % 60)).slice(-2);
   const minutes = ('0' + (Math.floor(tiemInMs / 60000) % 60)).slice(-2);
   const hours = ('0' + Math.floor(tiemInMs / 3600000)).slice(-2);
   return `${hours}:${minutes}:${seconds}`;
}
/**
 * Componente para medir tiempo en segundos.
 */
function Cronometro(props) {
   //Propiedades
   const { iconSize, setTiempo, setHoraIni } = props;
   //Estados de cotnrol
   const [delay, setDelay] = useState(null);
   const [isRunning, setIsRunning] = useState(false);
   const [time, setTime] = useState(0);
   const [offset, setOffset] = useState(0);
   const [timeS, setTimeS] = useState('');

   useEffect(() => {
      setTimeS(timeFormatter(time));
   }, [time]);

   async function update() {
      const newTime = time + (await delta());
      setTime(newTime);
      if (esFuncion(setTiempo)) {
         setTiempo(newTime);
      }
   }

   function delta() {
      const now = Date.now();
      const timePassed = now - offset;
      setOffset(now);
      return timePassed;
   }

   useInterval(update, delay);

   function start() {
      if (!isRunning) {
         setHoraIni(new Date());
         setOffset(Date.now());
         setIsRunning(true);
         setDelay(1000);
      }
   }

   function stop() {
      if (isRunning) {
         setDelay(null);
         setIsRunning(false);
      }
   }

   function reset() {
      setTime(0);
   }

   return (
      <Box alignItems="center">
         <Typography variant="button">{timeS}</Typography>
         {isRunning === false && time === 0 && (
            <IconButton size={iconSize} aria-label="iniciar" onClick={start}>
               <PlayCircleOutlineIcon />
            </IconButton>
         )}
         {isRunning === true && (
            <IconButton size={iconSize} aria-label="detener" onClick={stop}>
               <StopIcon />
            </IconButton>
         )}
         {isRunning === false && time > 0 && (
            <IconButton size={iconSize} aria-label="reanudar" onClick={start}>
               <PlayArrowIcon />
            </IconButton>
         )}
         {isRunning === false && time > 0 && (
            <IconButton size={iconSize} aria-label="reiniciar" onClick={reset}>
               <AutorenewIcon />
            </IconButton>
         )}
      </Box>
   );
}

Cronometro.propTypes = {
   /**
    * Tamaño de los iconos de inicio, detener y reiniciar.
    */
   iconSize: PropTypes.oneOf(["small", "medium"]),
   /**
    * Funcion a realizar cuando se detiene el cronometro con la siguiente firma:
    * 
    * - *tiempoTranscurrido*: int
    */
   setTiempo: PropTypes.func,
   /**
    * Funcion a realizar cuand se inicia el cronometro con la siguiente firma:
    * 
    * - *fechaDeInicio*: Date
    */
   setHoraIni: PropTypes.func
}
Cronometro.defaultProps = {
   iconSize: "small",
   setHoraIni: (fechaHoraInicial) => { }
}
export default Cronometro;